import { BMPrimitives, BMText } from "@traveloka/district-bloom";
import { Image, StyleSheet } from "react-native";
import { ERROR_DATA_NOT_FOUND_BASE64 } from "../../../../assets/error";
import BMView from "../../../../components/View/BMView";

const IMAGE_SIZE = 120;

type Props = {
  title: string;
  description: string;
};

export default function NoResult(props: Props) {
  const { title, description } = props;
  return (
    <BMView flex justify="center" align="center">
      <Image
        source={{ uri: ERROR_DATA_NOT_FOUND_BASE64 }}
        style={styles.image}
      />
      <BMView style={styles.textContainer} spacing="sm">
        <BMText style={styles.textAlignCenter} variant="titleSmall">
          {title}
        </BMText>
        <BMText style={styles.textAlignCenter} variant="paragraphNormal">
          {description}
        </BMText>
      </BMView>
    </BMView>
  );
}

const styles = StyleSheet.create({
  image: { width: IMAGE_SIZE, height: IMAGE_SIZE },
  textContainer: { marginTop: BMPrimitives.BMSize.xl4 },
  textAlignCenter: { textAlign: "center" },
});
